import baseService from './baseService';

export function saveCandidateInfo(params) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  return baseService.post('/refer_requests/candidate_info', params, config);
}
